import css from 'styled-jsx/css';

const styles = css.global`.checkbox-component .chk-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
}

.checkbox-component .label {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #222;
}

.checkbox-component .checkbox {
  margin-top: 3px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkbox-component .checkbox input {
  cursor: pointer;
  width: 24px;
  height: 24px;
  padding: 0;
  margin: 0;
  appearance: none;
}

.checkbox-component .checkbox .custom-style {
  outline: none;
  border: 1px solid #cc0000;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  margin: 0;
  border-radius: 4px;
  cursor: pointer;
  pointer-events: none;

  position: absolute;
  top: 0;
  left: 0;
}

.checkbox-component .checkbox .custom-style img {
  pointer-events: none;
  object-fit: contain;
}

.checkbox-component.radio .checkbox .custom-style {
  border-radius: 50%;
  border-width: 2px;
}

.checkbox-component.radio .checkbox .custom-style img {
  width: 24px;
  height: auto;
  object-fit: contain;
  flex: 1;
  max-width: unset;
}

.checkbox-component.radio.checked .checkbox .custom-style {
  background-color: transparent;
  border-color: transparent;
  overflow: visible;
  border-width: 0px;
}

.checkbox-component.radio .chk-container {
  gap: 16px;
}
`;

export default styles;